import React, { useState } from "react"
// import LinkButton from "@components/common/LinkButton"
// import { ArrowsOutSimpleIcon } from "@phosphor-icons/react"
import { navigate } from "gatsby"
import clsx from "clsx"

let activeLBCardRef = { deactivate: null }

const LookbookCard = ({ data, cardStyles, onClick, isSwiping }) => {
	const [imgLoaded, setImgLoaded] = useState(false)
	const [hovered, setHovered] = useState(false)
	const [isTouched, setIsTouched] = useState(false)

	const handleTouch = () => {
		if(isSwiping) return
		
		if(!isTouched) {
			if (activeLBCardRef.deactivate) {
				activeLBCardRef.deactivate()
			}
			setHovered(true)
			setIsTouched(true)
			activeLBCardRef.deactivate = () => {
				setHovered(false)
				setIsTouched(false)
			}
		} else if(isTouched) {
			if (data?.onClick) data?.onClick()
			else if (data?.url) navigate(data?.url)
			else if (onClick && hovered) onClick(data)
		}
	}

	return (
		<React.Fragment>
			<div
				className={clsx(
					`relative flex-auto md:flex-1 w-full h-full md:max-h-[328px] md:max-w-[328px] cursor-pointer group border-2`,
					hovered ? "border-black/100" : "border-black/0",
					!imgLoaded && "pointer-events-none"
				)}
				onTouchEnd={() => handleTouch()}
				onMouseEnter={() => setHovered(true)}
				onMouseLeave={() => setHovered(false)}
				onPointerUp={() => {
					if(hovered && !isSwiping) {
						if (data?.onClick) data?.onClick()
						else if (data?.url) navigate(data?.url)
						else if (onClick && hovered) onClick(data)
					}
				}}
			>
				{!imgLoaded && (
					<div className="absolute w-[328px] h-[328px] skeleton-solo" />
				)}
				<img
					className={clsx(
						"w-[328px] h-[328px] object-cover transition-all duration-300 ease-in-out",
						hovered ? "brightness-50" : "brightness-100",
						imgLoaded ? 'opacity-100' : 'opacity-0'
					)}
					src={data?.image}
					alt={data?.name}
					onLoad={() => setImgLoaded(true)}
				/>
				{data?.description && (
					<p className="product-description">{data?.description}</p>
				)}

				<div className="absolute hidden group-hover:block w-full top-1/2 bottom-1/2 m-auto text-center">
					<span className="text-white text-md">Shop the look</span>
					{/* <LinkButton
						label={data?.buttonLabel}
						className={clsx('tall-card-button btn-primary border-0')}
						icon={<ArrowsOutSimpleIcon size={20} weight="light" />}
						to={data?.url ?? "#"}
						onClick={onButtonClick}
					/> */}
				</div>
			</div>
		</React.Fragment>
	)
}

export default LookbookCard
